import { DiscoverSkeletonCard } from "@/components/DiscoverCard"

export default () => {
  return <div className="grid-card-list mt-4 sm:mt-5">
    {new Array(40).fill(0).map((item, i) => (
      <DiscoverSkeletonCard key={i} />
    ))}
  </div>
}
